import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './assets/fa/css/all.css'; // font-awesome icons
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.min.css'; // core css
import 'primeicons/primeicons.css'; // icons
import 'primeflex/primeflex.css'; // flex
import './index.scss';

import './locale'; // translations bundle

import { register } from 'serviceWorkerRegistration';
import { Loader } from 'components/_new/Loader';
import App from './App';
import { HistoryScrollRestoration } from './components/HistoryScrollRestoration';

if ('serviceWorker' in navigator) {
	register();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<BrowserRouter>
		<HistoryScrollRestoration />
		<Suspense fallback={<Loader text="..." />}>
			<App />
		</Suspense>
	</BrowserRouter>
);
